import React, { createRef } from "react"

/**
 * Currently only the type=continuous is supported.
 *
 * @param props.type The spinner type (must be 'continuous')
 * @param props.autoLoop Will start the continuous spinner automatically
 */
class DfbSpinner extends React.Component {
  constructor(props) {
    super(props)

    this.baseClass = "dfb-Spinner"
    this.className = this.baseClass
    if (props.type) {
      this.className += ` ${this.baseClass}--${props.type}`
    }
    if (props.add_class) {
      this.className += ' ' + props.add_class
    }

    this.spinnerRef = createRef()
  }

  /* Never update, since contents are rendered by personalization */
  shouldComponentUpdate() {
    return false
  }

  initAutoLoop() {
    if (this.spinnerRef.current && this.spinnerRef.current.dfbSpinner) {
      // React hydration might remove the svg, in that case we need to call init again
      if (!this.spinnerRef.current.childNodes || !this.spinnerRef.current.childNodes.length) {
        this.spinnerRef.current.dfbSpinner.init()
      }
      this.spinnerRef.current.dfbSpinner.loop()
    } else {
      window.setTimeout(this.initAutoLoop.bind(this), 100)
    }
  }

  componentDidMount() {
    if (this.props.autoLoop) {
      this.initAutoLoop()
    }
  }

  loop() {
    const spinner = this.spinnerRef.current
    if (spinner && spinner.dfbSpinner) {
      spinner.dfbSpinner.loop()
    }
  }

  stop() {
    const spinner = this.spinnerRef.current
    if (spinner && spinner.dfbSpinner) {
      spinner.dfbSpinner.stop()
    }
  }

  destroy() {
    const spinner = this.spinnerRef.current
    if (spinner && spinner.dfbSpinner) {
      spinner.dfbSpinner.destroy()
      this.spinnerRef.current = null
    }
  }

  render() {
    return (
      <div className={this.className} role="progressbar" ref={this.spinnerRef}>
      </div>
    )
  }
}

export default DfbSpinner
